import * as Fetch from '@/helpers/fetch'

export const getEventCodeConfigs = async (): Promise<Fetch.HttpResponse> => {
  const url = `${process.env.VUE_APP_STORAGE_CONFIG_URL}/event_code_configs_2.json?t=${new Date().getTime()}`
  const options = {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0',
    },
  }
  try {
    const result = await Fetch.get(url, options)
    return result
  } catch (error) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}
